export default "__VITE_ASSET__aa07577d__"